// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleBroken16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-broken': IconCircleBroken;
    }
}

/**
 * The icon component for the 'circleBroken' icon
 */
export class IconCircleBroken extends IconSvg {
    public constructor() {
        super(circleBroken16X16);
    }
}

registerIconSvg('icon-circle-broken', IconCircleBroken);
export const iconCircleBrokenTag = 'nimble-icon-circle-broken';
